import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAoUhiQh4aIUs4SypXmN-U0mGobCMj3ORM",
  authDomain: "familydashboard-f03ba.firebaseapp.com",
  projectId: "familydashboard-f03ba",
  storageBucket: "familydashboard-f03ba.firebasestorage.app",
  messagingSenderId: "833354030572",
  appId: "1:833354030572:web:5e48646efcb0332f0934c9"
};
const app = initializeApp(firebaseConfig);

const appCheckSiteKey = process.env.REACT_APP_FIREBASE_APPCHECK_KEY;
const appCheckEnabled = process.env.REACT_APP_ENABLE_APPCHECK === "true";
if (appCheckEnabled && appCheckSiteKey && typeof window !== "undefined") {
  const params = new URLSearchParams(window.location.search || "");
  const isDesktopShell = params.get("desktop") === "1" || params.get("mode") === "desktop";
  const protocol = window.location.protocol || "";
  const isLocalhost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";
  const supportedWebContext = protocol === "http:" || protocol === "https:";

  // Avoid App Check in desktop shell / file origins where reCAPTCHA token exchange returns 400.
  if (!isDesktopShell && !isLocalhost && supportedWebContext) {
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(appCheckSiteKey),
      isTokenAutoRefreshEnabled: true,
    });
  }
}

export const db = getFirestore(app);
export const functions = getFunctions(app);
export { app };
